export default "__VITE_ASSET__iXXlrJ8O__"